import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../../../lib/config/config.service";
import { CacheHeaders } from "../../../../lib/cache-interceptor/cache-headers";
import { UserMessageData, UserMessageType } from "../domain/models/user-message.model";

@Injectable({
  providedIn: "root",
})
export class UserMessageRemote {
  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
  ) {}

  getMessages(entityIds?: number[], messageType?: UserMessageType): Observable<UserMessageData[]> {
    let params = new HttpParams();

    if (messageType) {
      params = params.set("messageType", messageType);
    }

    (entityIds ?? []).forEach(id => {
      params = params.append("entityIds", id.toString());
    });

    return this.http.get<UserMessageData[]>(
      `${this.configService.environment.messages.url}/api/messages`,
      {
        headers: this.configService.environment.cache.mediumLived,
        params,
      }
    );
  }

  dismissEntityMessage(messageId: number, entityId: number, dismiss: boolean): Observable<void> {
    return this.updateMessage(
      `${this.configService.environment.messages.url}/api/messages/${messageId}/entities/${entityId}`,
      dismiss
    );
  }

  dismissCustomerMessage(messageId: number, customerId: number, dismiss: boolean): Observable<void> {
    return this.updateMessage(
      `${this.configService.environment.messages.url}/api/messages/${messageId}/customers/${customerId}`,
      dismiss
    );
  }

  private updateMessage(url: string, dismiss: boolean): Observable<void> {
    return this.http.put<void>(
      url,
      { dismiss },
      {
        headers: {
          [CacheHeaders.Invalidate]: [
            `${this.configService.environment.messages.url}/api/messages`,
          ],
        },
      }
    );
  }
}
